<template>
  <div>
    <a-card
      class="column-card box-shadow"
      :bordered="false"
      style="min-height: 400px"
    >
      <a-tabs tab-position="left" :default-active-key="currentTab" v-model="currentTab" @change="getCmsList">
        <a-tab-pane key="12" tab="历史前沿">
          <a-list :dataSource="cmsDataSource">
            <a-list-item
              class="cms-item"
              slot="renderItem"
              slot-scope="item"
              @click="toCmsDetail(item)"
            >
              <span class="cms-title">{{ item.cmsTitile }}</span>
              <span class="cms-time">{{ item.createTime }}</span>
            </a-list-item>
          </a-list>
        </a-tab-pane>
        <a-tab-pane key="11" tab="活动概况">
          <a-list :dataSource="cmsDataSource">
            <a-list-item
              class="cms-item"
              slot="renderItem"
              slot-scope="item"
              @click="toCmsDetail(item)"
            >
              <span class="cms-title">{{ item.cmsTitile }}</span>
              <span class="cms-time">{{ item.createTime }}</span>
            </a-list-item>
          </a-list>
        </a-tab-pane>
        
        <a-tab-pane key="13" tab="活动章程">
          <a-list :dataSource="cmsDataSource">
            <a-list-item
              class="cms-item"
              slot="renderItem"
              slot-scope="item"
              @click="toCmsDetail(item)"
            >
              <span class="cms-title">{{ item.cmsTitile }}</span>
              <span class="cms-time">{{ item.createTime }}</span>
            </a-list-item>
          </a-list>
        </a-tab-pane>
        <a-tab-pane key="-1" tab="联系方式">
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>

<script>
import { getAction } from "@/api/manage";

export default {
  data() {
    return {
      cmsDataSource: [],
      currentTab: '11'
    };
  },
  created() {
    console.log(this.currentTab);
    if (this.$route.query.type) {
      this.currentTab = this.$route.query.type;
    }else{

    }
    console.log(this.currentTab);
    this.getCmsList(this.currentTab);
  },
  watch:{
    $route(v){
      if (this.$route.query.type) {
        this.currentTab = this.$route.query.type;
      }else{
        this.currentTab = "11"
      }
      this.getCmsList(this.$route.query.type);
    }
  },
  methods: {
    getCmsList(type) {
      this.cmsType = type;
      this.cmsDataSource = [];
      if(type == -1){
        this.$router.push({path:'/cms/detail',query:{'id':'1588454988635541505'}})
        return
      }
      getAction("/teaching/teachingCms/getCmsList", {
        cmsStatus: 1,
        cmsType: type,
        pageSize: 10,
      }).then((res) => {
        if (res.success) {
          this.cmsDataSource = res.result.records;
        }
      });
    },
    toCmsDetail(item) {
      let route = this.$router.resolve({
        path: "/cms/detail",
        query: {
          id: item.id,
        },
      });
      window.open(route.href, '_blank');
    },
  },
};
</script>

<style lang="less" scoped>
.cms-item{
  cursor: pointer;
}
</style>